const DURATION = 1500;

function formatNumber(value) {
    return Math.round(value).toLocaleString('de-DE');
}

function animateNumber(el, target) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = formatNumber(target);
        return;
    }

    const start = performance.now();

    function step(now) {
        const progress = Math.min((now - start) / DURATION, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = formatNumber(target * eased);

        if (progress < 1) {
            requestAnimationFrame(step);
        }
    }

    requestAnimationFrame(step);
}

export function initCountUp(query = document.querySelectorAll('.js-countUp')) {
    for (const wrapper of query) {
        if (wrapper.dataset.countUpInit) {
            continue;
        }
        wrapper.dataset.countUpInit = "true";

        const observer = new IntersectionObserver((entries, obs) => {
            for (const entry of entries) {
                if (!entry.isIntersecting) {
                    continue;
                }
                const target = parseFloat(entry.target.dataset.countUpTarget) || 0;
                const value = entry.target.querySelector('.js-countUpValue');
                if (value) {
                    animateNumber(value, target);
                }
                obs.unobserve(entry.target);
            }
        }, {threshold: 0.5});

        wrapper.querySelectorAll('.js-countUpNumber').forEach(el => observer.observe(el));
    }
}
